import {
  useStateXSelector,
  useStateXWritableSelector,
} from '@cloudio-saas/statex';
import { Switch } from '@mui/material';
import { ItemIdUpdater } from 'components/Popup/TreePopup';
import { activeItemSelector } from 'designer/activeItemSelector';
import { TreeType } from 'layout/Sidebar/panels/TreeView/state';
import { usePlatform } from 'platform/PlatformHooks';
import React, { forwardRef, useState } from 'react';
import Entries from './Entries';

type Props = {
  treename: string;
  onSelect: (text: string) => void;
  height: number;
  width: number;
  pageUid: string;
  appUid: string;
};

const ItemProperties = ({
  treename,
  onSelect,
  height,
  width,
  pageUid,
  appUid,
}: Props) => {
  const [hideEmptyProps, setHideEmptyProps] = useState(true);
  const [selectedProp, setSelectedProp] = useState('');
  const platform = usePlatform();
  const { itemId } = useStateXSelector(activeItemSelector, {
    params: { appUid, treename, pageId: pageUid },
    props: platform,
  });
  const getFilteredProperties = (): string[] => {
    const item = platform.getItem(appUid, pageUid, itemId);
    const mgr = platform.getManager(itemId);
    let props: string[] = [];
    if (mgr && item) {
      props = Object.keys(mgr?.props);
      // console.log(item.props);
    }

    if (item && hideEmptyProps) {
      return Object.keys(item.props);
    }
    return props;
  };

  const onClick = (value: string) => {
    // console.log(`$page.${itemId}.${value}`);
    setSelectedProp(value);
    onSelect(`$.$page.${itemId}.${value}`);
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        data-tip="Hide Empty Props"
        data-tip-at="left"
        style={{ position: 'absolute', right: 16 }}
      >
        <Switch
          checked={hideEmptyProps}
          onChange={() => setHideEmptyProps(!hideEmptyProps)}
        />
      </div>
      <Entries
        entries={getFilteredProperties()}
        onClick={onClick}
        height={height}
        title="Choose a property"
        width={width}
        value={selectedProp}
        getLabel={(value) => value}
      />
    </div>
  );
};

export default ItemProperties;

export const ItemIdPropertyPicker = forwardRef(
  (
    {
      appUid,
      treename,
      pageUid,
    }: { appUid: string; treename: TreeType; pageUid: string },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const platform = usePlatform();
    const [{ itemId }, setActiveItem] = useStateXWritableSelector(
      activeItemSelector,
      {
        params: { appUid, treename, pageId: pageUid },
        props: platform,
      },
    );

    const onPickId = (pickedId: string) => {
      setActiveItem({
        appUid,
        pageId: pageUid,
        itemId: pickedId,
        expand: false,
        treename,
      });
    };
    return (
      <ItemIdUpdater
        appUid={appUid}
        ref={ref}
        treename={treename}
        pickedId={itemId}
        onPickId={onPickId}
        btnLabel="Update Item ID"
        pageId={pageUid}
      />
    );
  },
);
